import * as React from 'react';
import { translation, dateFormatter, TimeFormat, translationForMts } from 'easit--localization';
import { CategoryIcon } from 'common--design-library';
import { NoResultsEmptyList } from '../../common/noResults/noResults';

interface ICalendarListItem {
    id: number;
    graphicsPresentationId: number;
    categoryPathName: string;
    name: string;
    isLive: boolean;
    time: Date;
    isVideoStreamAvailable: boolean;
    hasActivePrematch: boolean;
}

export interface ICalendarList {
    items: ICalendarListItem[];
    canShowLinkForLiveOnly: boolean;
    onGoToDetail: (eventId: number, goToPrematch: boolean) => void;
}

export const CalendarList: React.FC<ICalendarList> = (props: ICalendarList) => {
    const t = translationForMts();
    return <>
        {
            props.items.length === 0
                ? <NoResultsEmptyList key={'no_results'} message={translation().no_results} />
                : <table className="calendar-table">
                    <thead>
                        <tr>
                            <th className="start-time-col">{t.calendar_startTime}</th>
                            <th>{t.calendar_event}</th>
                            <th>{t.calendar_category}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            props.items.map(event => {
                                const canShowLink = !props.canShowLinkForLiveOnly || event.isLive || event.hasActivePrematch;
                                return <tr key={event.id}>
                                    <td className="start-time-col">{dateFormatter.formatTime(event.time, TimeFormat.HHMM)}</td>
                                    <td>
                                        <div className="event-col">
                                            <CategoryIcon categoryIconId={event.graphicsPresentationId} />
                                            {event.isLive ? <span className="live-sign">LIVE</span> : ""}
                                            <span className={`event-name ${canShowLink ? "link" : ""}`}
                                                onClick={() => { if (canShowLink) { props.onGoToDetail(event.id, (!event.isLive && event.hasActivePrematch)); } }}>{event.name}
                                            </span>
                                            {
                                                event.isVideoStreamAvailable &&
                                                <span className={`fa fa-desktop ml-2 ${canShowLink ? 'link' : ''}`}
                                                    onClick={() => { if (canShowLink) { props.onGoToDetail(event.id, false); } }}>
                                                </span>
                                            }
                                        </div>
                                    </td>
                                    <td className="category-col">
                                        {event.categoryPathName}
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
        }
    </>
}